angular.module('jv.campaigns.email-campaign-modal.directive', [
    'jv.Common.Modal',
    'AppCtrl.contact.service'
])
.directive('jvEmailCampaignModal', [function() {
    return {
        scope: {
            hide: '&',
            show: '=',
            onSelect: '&'
        },
        controller: 'jvEmailCampaignModalController',
        templateUrl: '../campaign2/modals/emailCampaignModal.html'
    };
}])
.filter('statusPrint', function() {
    return function(status, active, inactive) {
        if(status === "IN_PROGRESS") {
            return active;
        } else {
            return inactive;
        }
    }
})
.controller('jvEmailCampaignModalController', [
    '$scope', 'contactService',
    function ($scope, contactService) {
        var state = $scope.state = {};
        function search() {
            var args = {
                page: state.page,
                keywords: state.query,
                status: "IN_PROGRESS"
            }
            angular.extend(args, {type: "EMAIL", hasContentFlag: false});
            contactService.getCampaignsNoBroadcast(args, resetScope);
        }

        function resetScope(results) {
            state.campaigns = results.resultList;
            state.start = (results.page * results.pageCount) + 1;
            state.end = (results.page + 1) * results.pageCount;
            state.totalNumber = results.resultCount;
            state.page = results.page;
            state.totalPages = Math.ceil(state.totalNumber / results.pageCount);
        }

        state.query = "";
        state.page = 0;
        state.selectedCampaign = {index:""};

        $scope.$watch('state.selectedCampaign.index', function(newVal) {
            if (newVal) {
                angular.forEach(state.campaigns, function(campaign) {
                    if(campaign.eid === newVal) {
                        $scope.campaignObj = campaign;
                    }
                });
            }
        });

        $scope.select = function(campaignObj) {
            $scope.onSelect({ campaign: campaignObj });
            $scope.hide();
        }

        $scope.search = function() {
            state.page = 0;
            search();
        };

        $scope.paginate = function(forward) {
            if(forward) {
                state.page++;
            } else {
                state.page--;
            }
            search();
        };

        search();
    }

]);